import { render, staticRenderFns } from "./ManageLocationForm.vue?vue&type=template&id=5bc02130&scoped=true"
import script from "./ManageLocationForm.vue?vue&type=script&lang=js"
export * from "./ManageLocationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc02130",
  null
  
)

export default component.exports